import { render } from "./CardRequirementsComponent.vue?vue&type=template&id=49e9c006&ts=true"
import script from "./CardRequirementsComponent.vue?vue&type=script&lang=ts"
export * from "./CardRequirementsComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__